import React, { useState } from 'react';
import './styles.css';

const Navbar: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-title">Standard Coil Co.</div>
      <div className="navbar-account">
        <img
          src="https://i.pravatar.cc/40?img=3"
          alt="Account"
          className="navbar-pfp"
          onClick={() => setOpen((o) => !o)}
        />
        {open && (
          <div className="navbar-dropdown">
            <button>Order History</button>
            <button>Account Settings</button>
            <button>Logout</button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
